import './AddressList.scss';
import Component from './AddressList.js';
export default Component;
